import React, { useState } from "react"

import ButtonOutline from "./button-outline"

import { onClickAddFriend } from "../utils/hook"

type Props = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}

const FooterRegistration: React.FC<Props> = ({
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
}) => {
  const [isClosed, setClosed] = useState(false)
  const onClose = () => {
    setClosed(true)
  }
  return isClosed ? null : (
    <div className="w-full flex justify-center">
      <ButtonOutline classes="py-2 pl-5 pr-4" color="green-800" fontSize="sm">
        <div className="flex items-center">
          <div
            onClick={() => {
              onClickAddFriend({ utmSource, utmMedium, utmCampaign, utmContent })
            }}
          >
            <span>LINEで開く</span>
          </div>
          <span className="font-medium ml-1">|</span>
          <span className="font-normal ml-2" onClick={onClose}>
            x
          </span>
        </div>
      </ButtonOutline>
    </div>
  )
}

export default FooterRegistration
